import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import moment from "jalali-moment";

import Coin from "./coin";
import Currency from "./currency";
import BgCurrency from "../../assets/icons/arz-bg.svg";
import BgCoin from "../../assets/icons/seke-bg.svg";
import "./main.css";
import { useDispatch } from "react-redux";
import {
  yesterdayVisitorsAction,
  todayVisitorsAction,
  totalVisitorsAction,
} from "../../store/action";

const Main = ({ showSidbarMarginLeft }) => {
  const [coins, setCoins] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [currUpdatedAt, setCurrUpdatedAt] = useState();
  const [coinUpdatedAt, setCoinUpdatedAt] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getUpdateAtCoin`)
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        setCoinUpdatedAt(
          moment(res.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSZ ").format(
            "jYYYY/jM/jD HH:mm z"
          )
        );
      })

      .catch((err) => {
        console.log(err);
      });
  }, [setCoinUpdatedAt]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getUpdateAtCurrency`)
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        setCurrUpdatedAt(
          moment(res.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSZ ").format(
            "jYYYY/jM/jD HH:mm z"
          )
        );
      })

      .catch((err) => {
        console.log(err);
      });
  }, [setCurrUpdatedAt]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getallcoins`)
      .then((respone) => {
        return respone.json();
      })
      .then((res) => {
        const arr = [];
        arr.push(res[0]);
        arr.push(res[5]);
        arr.push(res[1]);
        arr.push(res[2]);
        arr.push(res[6]);
        arr.push(res[4]);
        arr.push(res[3]);
        arr.push(res[7]);
        setCoins(arr);
      })
      .catch((err) => {
        console.log(err);
      });

    fetch(`${process.env.REACT_APP_URL}/api/getallcurrencies`)
      .then((respone) => {
        return respone.json();
      })
      .then((res) => {
        setCurrencies(res.AllCurrensies);

        dispatch(yesterdayVisitorsAction(res.yesterdayCountVal));
        dispatch(todayVisitorsAction(res.todayCountVal));
        dispatch(totalVisitorsAction(res.totalCountVal));
      })
      .catch((err) => {
        console.log(err);
      });

    const socket = io(`${process.env.REACT_APP_URL}`, {
      // transports: ["websocket"],
      transports: ["polling"],
    });

    socket.on("getCurrencies", (data) => {
      setCurrencies(data);
    });

    socket.on("getCoins", (data) => {
      const arr = [];
      arr.push(data[0]);
      arr.push(data[5]);
      arr.push(data[1]);
      arr.push(data[2]);
      arr.push(data[6]);
      arr.push(data[4]);
      arr.push(data[3]);
      arr.push(data[7]);
      setCoins(arr);
    });
  }, []);

  return (
    <div className="">
      <div
        style={{
          backgroundImage: `url(${BgCurrency})`,
          backgroundRepeat: "no-repeat",
        }}
        className={`currency-class bg-[#606161] bg-center-top sticky top-0 `}
      >
        <Currency
          data={currencies}
          showSidbarMarginLeft={showSidbarMarginLeft}
          currUpdatedAt={currUpdatedAt}
        />
      </div>
      <div
        style={{
          backgroundImage: `url(${BgCoin})`,
          backgroundRepeat: "no-repeat",
        }}
        className={"coin-class bg-[#808083] bg-bottom b-24 sticky top-0 "}
      >
        <Coin
          data={coins}
          showSidbarMarginLeft={showSidbarMarginLeft}
          coinUpdatedAt={coinUpdatedAt}
        />
      </div>
    </div>
  );
};

export default Main;
